import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TranslateModule } from '@ngx-translate/core';

import { LanguagePickerComponent } from './language-picker.component';

@NgModule({
  declarations: [LanguagePickerComponent],
  imports: [CommonModule, TranslateModule],
  exports: [LanguagePickerComponent]
})
export class LanguagePickerModule {}
